import styles from "./layout.module.css";

export function Layout({ children }) {
  return (
    <div className={styles.layout}>
      <div className={styles.animation} />
      <div className={styles.content}>{children}</div>
    </div>
  );
}
